/** Browser storage for last accepted legal document versions (mirrors DB when signed in). */
export const legalAcceptanceLocalStorageKey = "scriptea_legal_acceptance";

/** Session-only: user dismissed the pre-effective-date reminder for this published version pair. */
export const legalAcceptanceSoftDismissSessionKey =
  "scriptea_legal_soft_dismiss";
